import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import GlossaryPage from "./GlossaryPage";
import OptionStrategies from "./OptionStrategies";

import "./App.css";

function Sidebar() {
  return (
    <aside className="sidebar">
      <nav>
        <ul>
          <li>
            <Link to="/">🏠 Главная</Link>
          </li>
          <li>
            <Link to="/glossary">📘 Глоссарий</Link>
          </li>
                                                  <li><Link to="/strategies">📈 Стратегии</Link></li>
        </ul>
      </nav>
    </aside>
  );
}

function HomePage() {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <header className="header">
          <img
  src="/logo.png"
  alt="Options.ru Logo"
  style={{ height: "200px", marginBottom: "1rem" }}
/>
          <h1>Добро пожаловать на Options.ru</h1>
          <p>Ваш путь к умной торговле опционами</p>
          
        </header>

<section
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "2rem",
    flexWrap: "wrap",
    marginBottom: "3rem",
  }}
>
  {[
    {
      title: "Данные рынка в реальном времени",
      desc: "Получайте доступ к живым данным опционов и анализируйте тренды на лету",
    },
    {
      title: "Умные торговые инструменты",
      desc: "Мощные инструменты для стратегического планирования и оптимизации сделок",
    },
    {
      title: "Калькулятор оценки опционов",
      desc: "Используйте модель Black-Scholes и другие методы для оценки стоимости опционов",
    },
    {
      title: "Симулятор стратегий",
      desc: "Тестируйте опционные стратегии на исторических данных и в различных сценариях рынка",
    },
    {
      title: "Анализ волатильности",
      desc: "Оценивайте историческую и подразумеваемую волатильность для лучших решений",
    },
  ].map((feature, i) => (
    <div
      key={i}
      style={{
        width: "300px",
        padding: "1rem",
        border: "1px solid #ddd",
        borderRadius: "10px",
        textAlign: "center",
      }}
    >
      <h3>{feature.title}</h3>
      <p>{feature.desc}</p>
    </div>
  ))}
</section>



        <footer className="footer" style={{ textAlign: "center", marginTop: "2rem" }}>
          (c) 2025 Options.ru. Все права защищены.
        </footer>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/glossary" element={<GlossaryPage />} />
            <Route path="/strategies" element={<OptionStrategies />} />
            <Route path="/strategies" element={<OptionStrategies />} />
      </Routes>
    </Router>
  );
}

export default App;